module.exports = __webpack_public_path__ + "static/media/cross-icon-white-round.41f2cb10.svg";